<template>
  <div class="outer">
    <div class="inner">
      <p>常见问题</p>
      <ul class="content">
        <li v-for="(item,index) in question" :key="index" @click="goDetail(index)">
            <span class="question">{{item}}</span>
            <img src="../assets/image/row.png" alt />
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      question: ["为什么视频显示「审核中」/播放量一直为0？","视频播放、上传、录制、编辑、保存相关问题？","如何删除自己的视频？","为什么我的视频显示「视频不见啦」？","账号（登录、换绑、修改资料、个人主页）相关问题？","视频推荐（不感兴趣、推荐重复、总推荐一类）","功能故障","举报/合作/侵权"]
    };
  },
  methods:{
    goDetail(index){
      this.$router.push(`/feedBackDetail/${index}`)
    }
  }
};
</script>
<style lang="scss" scoped>
.outer {
  padding: 40px 30px;
  .inner {
    p {
      margin-bottom: 44px;
      font-size: 26px;
      font-weight: 500;
      color: rgba(102, 102, 102, 1);
    }
    .content {
      li {
        margin-bottom: 45px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        span {
          font-size: 30px;
          font-weight: 400;
          color: rgba(1, 1, 1, 1);
          margin-right: 30px;
        }
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
}
</style>